module.exports = __webpack_public_path__ + "assets/img/DS-room2 (2).564e50bd.jpg";